import React from "react";
import { Input } from "antd";
import { cn } from "../../utils/cn";
const CommonInput = ({ placeholder, icon, value, onChange, className, type, ...props }) => {
  const InputComponent = type === "password" ? Input.Password : Input;
  return (
    <>
      <InputComponent
        size="large"
        placeholder={placeholder}
        prefix={icon}
        value={value}
        onChange={onChange}
        type={type}
        className={cn(
          "border hover:!border-primary focus:!border-primary",
          className
        )}
        {...props}
      />
    </>
  );
};
export default CommonInput;
